<template>
    <a-spin :spinning="loading">
        <div class="content">
            <div v-if="dataSource.length" class="goods-list" @scroll="onScroll">
                <ul>
                    <li v-for="(item, index) in dataSource" :key="index">
                        <div class="img-box">
                            <img :src="item.cover">
                            <div class="text">
                                <div class="title">{{item.name}}</div>
                                <div class="desc">{{item.course_name}}</div>
                            </div>
                        </div>
                        <div class="other">
                            <span class="times">{{timeFormat(item.insert_time)}}</span>
                            <a-button type="primary" @click="sendCourse(item, 'chapter')">发送</a-button>
                        </div>
                        <div class="process"><span :class="item.study_per == 100 ? 'suc' : ''" :style="'width:' + item.study_per + '%'"></span></div>
                    </li>
                </ul>
                <load-more :status="loadStatus"></load-more>
            </div>
            <div v-else>
                <a-empty :image="simpleImage" description="暂无记录" />
            </div>
        </div>
    </a-spin>
</template>

<script>
    import { Empty } from 'ant-design-vue';
    import { getAction } from '@/api/manage'
    import { ListMixin } from '@/mixins/ListMixin'
    import { dateFormat } from '@/utils/util'
    import loadMore from '@/components/loadMore.vue'
    export default {
        name: 'StudyListModal',
        props:['title'],
        mixins: [ListMixin],
        components: {
            loadMore,
        },
        beforeCreate() {
            this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
        },
        data() {
            return {
                loading: true,
                url: {
                    list: 'scrm/work-state/course-study'
                },
                queryParam: {
                    title: '',
                    customer_id: ''
                },
                isSend: false, // 防止重复获取
                loadStatus: 'loading',
            }
        },
        created() {
            this.getDetails();
        },
        mounted() {
        },
        methods: {

            // 处理时间
            timeFormat(times) {
                return dateFormat(times * 1000, 'Y-m-d H:i')
            },

            getDetails() {
                if(this.isSend) {return}
                var params = this.getQueryParams(); //查询条件
                if(this.ipagination.current == 1) {
                    this.loading = true;
                    this.dataSource = [];
                }
                this.isSend = true;
                this.loadStatus = 'loading'
                getAction(this.url.list, params).then((res) => {
                    if (res.data && res.data.list.length >= 0) {
                        this.dataSource = this.dataSource.concat(res.data.list);
                        if (res.data.list.length < this.ipagination.pageSize) {
                            this.loadStatus = 'noMore'
                        }
                        else {
                            this.loadStatus = 'loading'
                            this.ipagination.current++
                        }
                    }
                })
                .finally(res => {
                    this.loading = false;
                    this.isSend = false;
                });
            },

            onScroll(e) {
                if(this.loadStatus == 'noMore') {
                    return
                }
                if(e.target.scrollTop + e.target.clientHeight + 400 >= e.target.scrollHeight) {
                    this.getDetails()
                }
            }
        },
        watch: {

            title() {
                this.queryParam.title = this.title;
                this.ipagination.current = 1
                this.getDetails();
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    // @import '@/style/less/func';
    .default-color {
        color: #13C2C2;
    }
</style>
